import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import Calculator from 'app/theme/calculator'

import heroImg from 'assets/img/affordable-catering-hero.jpg'
import affordableCatering1 from 'assets/img/affordable-catering-1.jpg'
import affordableCatering2 from 'assets/img/affordable-catering-2.jpg'
import affordableCatering3 from 'assets/img/affordable-catering-3.jpg'
import affordableCatering4 from 'assets/img/affordable-catering-4.jpg'

export default function AffordableCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Affordable Catering Near You - Roaming Hunger</title>
        <meta name="og:title" content="Affordable Catering Near You"></meta>
        <meta name="description" content="Food trucks are an affordable catering option compared to traditional caterers. Need affordable catering for a corporate event, wedding or birthday? Book today."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Affordable Catering Near You"
          onButtonClick={openModal}
          description={(
            <div>
              If you're looking for affordable catering without sacrificing quality and experience,
              food trucks are the go to catering alternative to traditional options.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Food trucks are an affordable catering alternative"
          content="Compared to traditional catering, food trucks are an affordable catering option for events that don't require a wait staff, linens or other bells and whistles."
          image={affordableCatering1}
        />
        <OccasionPageGridRow
          heading="Don't sacrifice quality"
          content="Cheap caterers will often cut corners by serving smaller portions or use lower quality ingredients. As your liaison, we'll make sure that your caterers will serve the appropriate amount of food, at the quality that you expect."
          image={affordableCatering2}
          reverse
        />
      </OccasionPageGrid>

      <WhyWorkWithUs
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="We negotiate the best prices"
          content="Have a target price per person you are trying to stay under? We'll negotiate pricing for you. If a specific caterer is not budging, we have thousands more to choose from."
          image={affordableCatering3}
          reverse
        />
        <OccasionPageGridRow
          heading="Something for everyone"
          content="With 23,000 food truck caterers nationwide, we have options that will satisfy all of your guests. If you're looking to keep costs down, ask your Account Manager for food truck that serves multiple cuisine types."
          image={affordableCatering4}
        />
      </OccasionPageGrid>

      <CuisineTypes 
        baseUrl='/food-truck-catering' 
      />

      <HowItWorks
        heading="How Affordable Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Affordable Catering Works"
        onButtonClick={openModal}
      />

      <FeaturedClients
        onButtonClick={openModal}
      />

      <Calculator
        heading="How Much Does Affordable Catering Cost?"
        onButtonClick={openModal}
      />
    </Layout>
  )
}
